import * as React from "react";
import type { SVGProps } from "react";
const SvgPlus01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M12 4.8v14.4m7.2-7.2H4.8"
    />
  </svg>
);
export default SvgPlus01;
